import { useMutation } from '@tanstack/react-query';
import {
  IssueTemplateCreatedResponseDto,
  useApi,
  CreateIssueTemplateRequestDto,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export interface UseCreateIssueTemplateParams {
  onError?: (error: ExtendedAxiosError) => void;
}

export function useCreateIssueTemplate(params?: UseCreateIssueTemplateParams) {
  const api = useApi();

  return useMutation<
    IssueTemplateCreatedResponseDto,
    ExtendedAxiosError,
    CreateIssueTemplateRequestDto
  >({
    mutationKey: ['issueTemplates'],
    mutationFn: (data) =>
      api.issueTemplatesApi.createIssueTemplate(data).then((r) => r.data),
    onError: params?.onError,
  });
}
